export const ORDER_CREATED = 1;
export const ORDER_REMOVED = 2;
export const ORDER_ACTIVE = 3;
export const ORDER_COMPLETED = 4;
export const ORDER_DRAFT = 5;

export const DELIVERY_TAKEN = 1; //Принят водителем
export const DELIVERY_AT_LOADING = 2; //На погрузке
export const DELIVERY_ON_DISPATCH = 3; //В пути
export const DELIVERY_REST_PARKING = 4; //На отдыхе
export const DELIVERY_ARRIVED = 5; //Прибыл
export const DELIVERY_ON_UNLOADING = 6; //На разгрузке
export const DELIVERY_FINISHED = 7; //Завершён
export const DELIVERY_FOR_LOADING = 8; // Едет на погрузку
